const users = () => {

    const btnShows = document.querySelectorAll('.user-agents-show a');
    if (btnShows && btnShows.length > 0) {
        btnShows.forEach(function (el) {
            const outer = el.closest('.user-agents');
            el.addEventListener('click', function (evt) {
                evt.preventDefault();
                if (outer.classList.contains('is-active')) {
                    outer.classList.remove('is-active');
                } else {
                    outer.classList.add('is-active');
                }

            })
        })
    }

}

export {users}
